export default function Era() {
  return (
    <>
<section className="era" id="s-era">
  <div className="container">
    <h2>Build skills from patterns,<br /><span className="dim">automate your company</span></h2>
    <p className="era-sub">Every pattern TeamGrid finds can become a named skill — something that watches one part of your company and acts on its own. This is the skill library of a 120-person team.</p>
  </div>

  <div className="container-wide">
    <div className="skillpanel">
      <div className="sp-top">
        <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
        <span className="sp-title"><img src="/assets/mark-teamgrid.svg" alt="" />Skill Library</span>
        <span className="sp-meta"><b>6</b> skills · <b>4</b> active · built from your own patterns</span>
      </div>
      <div className="sp-body">
        <div className="sp-rail" id="spRail" role="tablist" aria-label="Skills built from patterns"></div>
        <div className="sp-detail" id="spDetail"></div>
      </div>
    </div>
    <div className="era-btns">
      <a className="btn-primary" href="/pattern-intelligence">Start with your patterns</a>
      <a className="btn-ghost" href="/features/org-intelligence">See how skills are built</a>
    </div>
  </div>
</section>
    </>
  );
}
